import React from 'react';
import { AD_ACTIVE } from 'common/lib/helpers/constants';
import PropTypes from 'prop-types';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';
import AdStatusRibbon from '../adStatusRibbon';
import AdAddress from '../adAddress';

const AdHeading = ({
    mainTitle,
    secondaryTitle,
    streetAddress,
    localAreaName,
    postNumber,
    postArea,
    adStatus,
    isSold,
}) => {
    const showRibbon = adStatus !== AD_ACTIVE || isSold;
    const { isMobile } = useDeviceSize();

    return (
        <>
            {showRibbon && <AdStatusRibbon adStatus={adStatus} isSold={isSold} />}
            {localAreaName && <span className="mb-16 text-22 block">{localAreaName}</span>}
            <h1 className={`mb-16 ${isMobile ? 'text-28' : 'text-34'}`}>{mainTitle}</h1>
            <h2 className={`mb-16 ${isMobile ? 'text-16' : 'text-22'}`}>{secondaryTitle}</h2>

            <AdAddress link postNumber={postNumber} postArea={postArea} streetAddress={streetAddress} />
        </>
    );
};

AdHeading.propTypes = {
    mainTitle: PropTypes.string.isRequired,
    secondaryTitle: PropTypes.string.isRequired,
    streetAddress: PropTypes.string,
    postNumber: PropTypes.string,
    postArea: PropTypes.string,
    adStatus: PropTypes.string,
    localAreaName: PropTypes.string,
    isSold: PropTypes.bool,
};

export default AdHeading;
